import { Button, Col, Container, Form, InputGroup, Row } from 'react-bootstrap';
import React, { ReactNode, useState } from 'react';

const FiltersSandbox = (): ReactNode => {
  const [state, setState] = useState({ test: '', test2: '' });
  const { test = '', test2 = '' } = state;

  const onChange = (name: string) => (event: React.ChangeEvent<HTMLInputElement>) => {
    setState({ ...state, [name]: event.target.value });
  };

  return (
    <Container className="p-2" fluid>
      <Row>
        <Col>
          <InputGroup>
            <Form.Control onChange={onChange('test')} value={test} />
            <Form.Control onChange={onChange('test2')} value={test2} />
            <Button variant="primary" onClick={console.log}>
              Set
            </Button>
          </InputGroup>
        </Col>
        <Col>
          <pre>{JSON.stringify(state, null, 2)}</pre>
        </Col>
      </Row>
    </Container>
  );
};
export default FiltersSandbox;
